/**
 * Shared UI helpers for priority badges + tags pills.
 * Kept tiny — used by TaskDetail, Dashboard, Report, PublicBoard.
 */
import { Badge } from "@/components/ui/badge";

export const PRIORITY_META = {
  high: { label: "High", cls: "border-rose-300 text-rose-800 bg-rose-50" },
  medium: { label: "Medium", cls: "border-amber-300 text-amber-800 bg-amber-50" },
  low: { label: "Low", cls: "border-slate-300 text-slate-700 bg-slate-50" },
};

export function PriorityBadge({ priority, dataTestId }) {
  if (!priority) return null;
  const m = PRIORITY_META[priority];
  if (!m) return null;
  return (
    <Badge variant="outline" className={`text-[10px] uppercase tracking-wider ${m.cls}`} data-testid={dataTestId || `priority-${priority}`}>
      {m.label}
    </Badge>
  );
}

export function TagPills({ tags, dataTestId }) {
  if (!tags || tags.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1" data-testid={dataTestId}>
      {tags.map((t) => (
        <span key={t} className="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-700 border border-slate-200">
          #{t}
        </span>
      ))}
    </div>
  );
}
